import { Divider } from 'antd';
import React from 'react';

import { Gap, SecondaryButton } from '@common/components';
import {
  SignInEmailFormRecordType,
  SignInPasswordForm,
} from '@identity/components';
import { useRedirectPath } from '@identity/hooks/use-redirect-path';

type UserConfirmationType = {
  setTitle: (param: string) => void;
  worksAuthInfo: SignInEmailFormRecordType;
  onChangeEmail?: () => void;
  onBackAction?: (action: (() => void) | null) => void;
};

export function SignInPageUserConfirmation({
  worksAuthInfo,
  setTitle,
  onChangeEmail,
  onBackAction,
}: UserConfirmationType) {
  setTitle('Welcome back');

  const { email } = worksAuthInfo;
  const redirectPath = useRedirectPath();

  const csrfTokenMeta = document.querySelector(
    'meta[name=csrf-token]'
  ) as HTMLMetaElement;
  const csrfParamMeta = document.querySelector(
    'meta[name=csrf-param]'
  ) as HTMLMetaElement;

  return (
    <Gap vertical fullWidth>
      <SignInPasswordForm
        email={email}
        onChangeEmail={onChangeEmail}
        onBackAction={onBackAction}
      />

      <Divider plain>Or</Divider>

      <form
        action="/works/auth/sso_initiate"
        method="post"
        style={{ width: '100%' }}
      >
        <input type="hidden" name="email" value={email} />
        {redirectPath && (
          <input type="hidden" name="redirect_path" value={redirectPath} />
        )}
        {csrfParamMeta && csrfTokenMeta && (
          <input
            type="hidden"
            name={csrfParamMeta.content}
            value={csrfTokenMeta.content}
          />
        )}
        <SecondaryButton
          htmlType="submit"
          size="large"
          style={{ width: '100%' }}
        >
          Sign in with SSO
        </SecondaryButton>
      </form>
    </Gap>
  );
}
